import React, { useState, useEffect } from "react";
import * as Style from "./styledComponents/PersonalInstruction";
import Safe from "../assets/images/DeathModuleNew/cash.png";
import funeralImg from "../assets/images/DeathModuleNew/funeral.png";
import penImage from "../assets/images/DeathModuleNew/penWhite.svg";

import SeeMore from "../assets/images/DeathModuleNew/more_horiz.png";
import helpIcon from "../assets/images/DeathModuleNew/IC_Help.png";
import AddModal from "./styledComponents/Modal/AddModal";
import AddFuneralModal from "./styledComponents/Modal/AddFuneralModal";
import UpdateFuneralModal from "./styledComponents/Modal/UpdateFuneralModal";
import UpdateModal from "./styledComponents/Modal/UpdateModal";
import Loader from "../components/styled-components/loader/loader";
import DEATH_API from "../apis/death.api";
import MODULE_API from "../apis/module.api";
import swal from "sweetalert";
import axios from "axios";
import menuIcon from "../assets/images/DeathModuleNew/Menu.png";
import List from "./styledComponents/Table/List";
import ListPaginated from "./styledComponents/Table/ListPaginated";
import { Modal } from "antd";
import Table from "./styledComponents/Table/Table";
import moment from "moment";
import ViewModal from "./styledComponents/Modal/ViewModal";
import setting from "../assets/SVGs/setting.svg";

export const Funeralwishes = (props) => {
  const cols = [
    {
      title: "Name of Expense",
      dataIndex: "placeName",
      //   sorter: (a, b) =>
      //     a.firstName > b.firstName ? 1 : a.firstName === b.firstName ? 0 : -1,
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Items Paid For",
      dataIndex: "paidFor",
      // sorter: (a, b) => a["Email"] > b["Email"],
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Amount Paid",
      dataIndex: "amount",
      //   sorter: (a, b) => a["secondPasswordGranted"] > b["secondPasswordGranted"],
      render: (record) =>
        record
          ? `${"$" + record.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
          : "N/A",
    },
    {
      title: "Date of Paid",
      dataIndex: "paymentDate",
      //   sorter: (a, b) => a["secondPasswordGranted"] > b["secondPasswordGranted"],
      render: (record) =>
        record ? moment(record).format("MM-DD-YYYY") : "N/A",
    },

    {
      title: "Notes",
      dataIndex: "note",
      // key: "account",
      // sorter: (a, b) => a["Notes"] > b["Notes"],
      // sorter: (a, b) =>
      //   a["Notes"] > b["Notes"] ? 1 : a["Notes"] === b["Notes"] ? 0 : -1,
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Location",
      dataIndex: "location",
      //   sorter: (a, b) => a["lastName"] > b["lastName"],
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Address",
      dataIndex: "address",
      // sorter: (a, b) => a["Phone"] > b["Phone"],
      render: (record) => (record ? record : "N/A"),
    },

    {
      title: "Director",
      dataIndex: "director",
      //   sorter: (a, b) => a["typeOfRelation"] > b["typeOfRelation"],
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNumber",
      //   sorter: (a, b) => a["secondPasswordGranted"] > b["secondPasswordGranted"],
      render: (record) => (record ? formatPhoneNumber(record) : "N/A"),
    },

    {
      title: "Action",
      render: (record, index) => {
        // console.log("index...>>>",record.idx);
        return (
          <div>
            <div
              onClick={() => {
                setDropdown(!dropdown);
                getSelectedRow(record.id);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "0px 16px",
                width: "5px",
              }}>
              <img src={menuIcon} alt="menuIcon"></img>
            </div>
            {dropdown && selectedIndex === record.id && (
              <>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}></div>

                <div class="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    {props.role !== "protrustee" && (
                      <li
                        className="liHover"
                        onClick={() => {
                          deleteSelectedRow(record.id);
                          setDropdown(false);
                        }}>
                        Delete
                      </li>
                    )}
                    {props.role !== "protrustee" && (
                      <li
                        className="liHover"
                        onClick={() => {
                          setShowUpdateModal(true);
                          setDropdown(false);
                        }}>
                        Update
                      </li>
                    )}
                    <li
                      className="liHover"
                      onClick={() => {
                        setDropdown(false);
                        setShowViewModal(true);
                      }}>
                      View
                    </li>
                  </ul>
                </div>
              </>
            )}{" "}
          </div>
        );
      },
    },
  ];
  const preferCols = [
    {
      title: "I Prefer",
      dataIndex: "placeName",

      // render: (record) => (record ? record : "N/A"),
      render: (fileName, record) => {
        console.log("record in table", record);
        return (
          (record.cremation && record.cremation) ||
          (record.burial && record.burial) ||
          "N/A"
        );
      },
    },
    {
      title: "Person I would like to be near",
      dataIndex: "personNextToMe",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Headstone inscription",
      dataIndex: "headStone",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Funeral home/Mortuary",
      dataIndex: "preferredFuneral",
      render: (record) => (record ? record : "N/A"),
    },

    {
      title: "Address",
      dataIndex: "address",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Phone Number",
      dataIndex: "phone",
      render: (record) => (record ? formatPhoneNumber(record) : "N/A"),
    },

    // {
    //   title: "Action",
    //   render: (record, index) => {
    //     return (
    //       <div>
    //         {" "}
    //         <img
    //           style={{ cursor: "pointer", marginRight: "1rem" }}
    //           src={menuIcon}
    //           alt="menuIcon"
    //           onClick={() => {
    //             console.log("recode", record.idx);
    //             setDropdown(!dropdown);
    //             console.log("alldata funeral", allFuneralData);
    //             // getSelectedRow(record.id);
    //           }}
    //         ></img>
    //         {dropdown && (
    //           <div class="dropdown">
    //             <ul className="dropdownul">
    //               {props.role !== "protrustee" && (
    //                 <li
    //                   className="liHover"
    //                   onClick={() => {
    //                     // deleteSelectedRow(record.id);
    //                     deleteFuneralWish();
    //                     setDropdown(false);
    //                   }}
    //                 >
    //                   Delete
    //                 </li>
    //               )}
    //               {props.role !== "protrustee" && (
    //                 <li
    //                   className="liHover"
    //                   onClick={() => {
    //                     setUpdateFuneralWishes(true);
    //                     setDropdown(false);
    //                   }}
    //                 >
    //                   Update
    //                 </li>
    //               )}
    //               <li
    //                 className="liHover"
    //                 onClick={() => {
    //                   setDropdown(false);
    //                   // setShowViewModal(true);
    //                 }}
    //               >
    //                 View
    //               </li>
    //             </ul>
    //           </div>
    //         )}{" "}
    //       </div>
    //     );
    //   },
    // },
  ];
  const placeCols = [
    {
      title: "Place",
      dataIndex: "preferredPlace",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Religious Preference",
      dataIndex: "religiousPreference",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Preferred Clergyman or Celebrant",
      dataIndex: "preferredClergyman",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Clothing Preference",
      dataIndex: "clothingPreference",
      render: (record) => (record ? record : "N/A"),
    },
  ];
  const personalCols = [
    {
      title: "Wedding Band",
      dataIndex: "weddingBand",
      // render: (record) => (record ? record : "N/A"),
      render: (fileName, record) => {
        console.log("record in table", record);
        return (
          (record.weddingBandReturnTo && record.weddingBandReturnTo) ||
          (record.weddingBand && record.weddingBand) ||
          "N/A"
        );
      },
    },
    {
      title: "Eyeglasses",
      dataIndex: "eyeGlasses",
      // render: (record) => (record ? record : "N/A"),
      render: (fileName, record) => {
        console.log("record in table", record);
        return (
          (record.eyeGlassesReturnTo && record.eyeGlassesReturnTo) ||
          (record.eyeGlasses && record.eyeGlasses) ||
          "N/A"
        );
      },
    },
    {
      title: "Watch",
      dataIndex: "watch",
      // render: (record) => (record ? record : "N/A"),
      render: (fileName, record) => {
        console.log("record in table", record);
        return (
          (record.watchReturnTo && record.watchReturnTo) ||
          (record.watch && record.watch) ||
          "N/A"
        );
      },
    },
    {
      title: "Floral Preference",
      dataIndex: "floralPreferences",
      render: (record) => (record ? record : "N/A"),
    },

    {
      title: "Musical Selections",
      dataIndex: "musicalSelections",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Religious or other readings",
      dataIndex: "religiousReadings",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Eulogy Delivered by",
      dataIndex: "eulogyDeliveredBy",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Favorite Charities",
      dataIndex: "favoriteCharities",
      render: (record) => (record ? record : "N/A"),
    },
  ];

  const fields = [
    {
      title: "Name Of Expense",
      type: "input",
      index: "NameOfPlace",
    },
    {
      title: "Items Paid For",
      type: "select",
      options: [
        "Funeral Home Services",
        "Casket",
        "Flowers",
        "Transportation",
        "Final Expense Insurance",
        "Cremation",
        "Embalming",
        "Body Preparation",
        "Facilities/Staff to manage viewing",
        "Hearse",
        "Legacy Website",
        "Service Car",
        "Memorial Printed Package",
        "Vault",
      ],
      index: "ItemsPaidFor",
    },
    {
      title: "Amount Paid",
      type: "currency",
      index: "AmountPaid",
    },
    {
      title: "Date Paid",
      type: "date",
      index: "DatePaid",
    },
    {
      title: "Notes",
      type: "textarea",
      index: "Notes",
    },
    {
      title: "Location (if applicable)",
      type: "input",
      index: "Location",
    },
    {
      title: "Address (if applicable)",
      type: "input",
      index: "Address",
    },
    {
      title: "Director (if applicable)",
      type: "input",
      index: "Director",
    },
    {
      title: "Phone Number (if applicable)",
      type: "phoneNumber",
      index: "PhoneNumber",
    },
  ];
  const funeralFields = [
    {
      title: "I Prefer",
      type: "Title",
      index: "title",
    },

    {
      title: "Prefer",
      type: "select",
      options: ["Burial", "Cremation"],
      index: "cremation1",
    },
    {
      title: "Person I would like to be buried near",
      type: "input",
      index: "personNextToMe",
    },
    {
      title: "Headstone Inscription",
      type: "input",
      index: "headStone",
    },
    {
      title: "Preferred Funeral Home/Mortuary",
      type: "input",
      index: "preferredFuneral",
    },
    {
      title: "Address",
      type: "input",
      index: "address",
    },
    {
      title: "Phone Number",
      type: "phoneNumber",
      index: "phone",
    },

    // {
    //   title: "Place of Services",
    //   type: "Title",
    //   index: "title",
    // },

    {
      title: "Place of Services",
      type: "radio",
      options: [
        "Mortuary/Funeral Home",
        "Memorial Park/Chapel at Cemetary",
        "Gravesite",
        "Family",
        "Church",
        "Other",
      ],
      index: "preferredPlace",
    },
    {
      title: "Religious Preference",
      type: "input",
      index: "religiousPreference",
    },
    {
      title: "Preferred Clergyman or Celebrant",
      type: "input",
      index: "preferredClergyman",
    },
    {
      title: "Clothing Preferrence",
      type: "input",
      index: "clothingPreference",
    },
    {
      title: "Personal Accessories",
      type: "Title",
      index: "title",
    },
    {
      title: "Wedding Band",
      type: "radio",
      options: ["Stay On", "Return To"],
      index: "weddingBand",
    },
    {
      title: "Watch",
      type: "radio",
      options: ["Stay On", "Return To"],
      index: "watch",
    },
    {
      title: "Eye Glasses",
      type: "radio",
      options: ["Stay On", "Return To"],
      index: "eyeGlasses",
    },

    {
      title: "Floral Preference",
      type: "input",
      index: "floralPreferences",
    },
    {
      title: "Musical Selectors",
      type: "input",
      index: "musicalSelections",
    },
    {
      title: "Religious or other reading",
      type: "input",
      index: "religiousReadings",
    },
    {
      title: "Eulogy Delivered By",
      type: "input",
      index: "eulogyDeliveredBy",
    },
    {
      title: "Favorite Charities",
      type: "input",
      index: "favoriteCharities",
    },
  ];
  const funeralUpdateFields = [
    {
      title: "I Prefer",
      type: "Title",
      index: "title",
    },

    {
      title: "Prefer",
      type: "select",
      options: ["Burial", "Cremation"],
      index: "cremation1",
    },
    {
      title: "Person I would like to be buried near",
      type: "input",
      index: "personNextToMe",
    },
    {
      title: "Headstone Inscription",
      type: "input",
      index: "headStone",
    },
    {
      title: "Preferred Funeral Home/Mortuary",
      type: "input",
      index: "preferredFuneral",
    },
    {
      title: "Address",
      type: "input",
      index: "address",
    },
    {
      title: "Phone Number",
      type: "phoneNumber",
      index: "phone",
    },

    {
      title: "Place of Services",
      type: "Title",
      index: "title",
    },

    {
      title: "Place of Services",
      type: "radio1",
      options: [
        "Mortuary/Funeral Home",
        "Memorial Park/Chapel at Cemetary",
        "Gravesite",
        "Family",
        "Church",
        "Other",
      ],
      index: "preferredPlace",
    },
    {
      title: "Religious Preference",
      type: "input",
      index: "religiousPreference",
    },
    {
      title: "Preferred Clergyman or Celebrant",
      type: "input",
      index: "preferredClergyman",
    },
    {
      title: "Clothing Preferrence",
      type: "input",
      index: "clothingPreference",
    },
    {
      title: "Personal Accessories",
      type: "Title",
      index: "title",
    },
    {
      title: "Wedding Band",
      type: "radio",
      options: ["Stay On", "Return To"],
      index: "weddingBand",
    },
    {
      title: "Watch",
      type: "radio",
      options: ["Stay On", "Return To"],
      index: "watch",
    },
    {
      title: "Eye Glasses",
      type: "radio",
      options: ["Stay On", "Return To"],
      index: "eyeGlasses",
    },

    {
      title: "Floral Preference",
      type: "input",
      index: "floralPreferences",
    },
    {
      title: "Musical Selectors",
      type: "input",
      index: "musicalSelections",
    },
    {
      title: "Religious or other reading",
      type: "input",
      index: "religiousReadings",
    },
    {
      title: "Eulogy Delivered By",
      type: "input",
      index: "eulogyDeliveredBy",
    },
    {
      title: "Favorite Charities",
      type: "input",
      index: "favoriteCharities",
    },
  ];
  const update_fields = [
    {
      title: "Name Of Expense",
      type: "input",
      index: "placeName",
    },
    {
      title: "Items Paid For",
      type: "select",
      options: [
        "Funeral Home Services",
        "Casket",
        "Flowers",
        "Transportation",
        "Final Expense Insurance",
        "Cremation",
        "Embalming",
        "Body Preparation",
        "Facilities/Staff to manage viewing",
        "Hearse",
        "Legacy Website",
        "Service Car",
        "Memorial Printed Package",
        "Vault",
      ],
      index: "paidFor",
    },
    {
      title: "Amount Paid",
      type: "currency",
      index: "amount",
    },
    {
      title: "Date Paid",
      type: "date",
      index: "paymentDate",
    },
    {
      title: "Notes",
      type: "textarea",
      index: "note",
    },
    {
      title: "Location",
      type: "input",
      index: "location",
    },
    {
      title: "Address",
      type: "input",
      index: "address",
    },
    {
      title: "Director",
      type: "input",
      index: "director",
    },
    {
      title: "Phone Number",
      type: "phoneNumber",
      index: "phoneNumber",
    },
  ];

  const [funeralWishes, setFuneralWishes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dropdown, setDropdown] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [addData, setaddData] = useState({});
  const [updateObject, setUpdateObject] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [addFuneralWishes, setAddFuneralWishes] = useState(false);
  const [updateFuneralWishes, setUpdateFuneralWishes] = useState(false);
  const [updateFuneralObject, setUpdateFuneralObject] = useState({});

  const [funeralData, setFuneralData] = useState({});

  const [tooltipModal, setTooltipModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);

  const [allFuneralData, setAllFuneralData] = useState({});
  const [servicesPlace, setServicesPlace] = useState([]);
  const [personalItems, setPersonalItems] = useState([]);
  const [prefer, setPrefer] = useState([]);

  function formatPhoneNumber(phoneWithCountryCode) {
    // Remove any non-numeric characters from the phone number
    const numericPhoneNumber = phoneWithCountryCode.replace(/\D/g, "");
    if (
      numericPhoneNumber.startsWith("1") &&
      numericPhoneNumber.length === 11
    ) {
      // Format as a USA number (e.g., +1 408-123-4567)
      return `+1 ${numericPhoneNumber.slice(1, 4)}-${numericPhoneNumber.slice(
        4,
        7
      )}-${numericPhoneNumber.slice(7)}`;
    } else if (
      numericPhoneNumber.startsWith("44") &&
      numericPhoneNumber.length === 12
    ) {
      // Format as a UK number (e.g., +44 20 1234 5678)
      return `+44 ${numericPhoneNumber.slice(2, 4)} ${numericPhoneNumber.slice(
        4,
        8
      )} ${numericPhoneNumber.slice(8)}`;
    } else if (
      numericPhoneNumber.startsWith("49") &&
      numericPhoneNumber.length === 12
    ) {
      // Format as a Germany number (e.g., +49 30 12345678)
      return `+49 ${numericPhoneNumber.slice(2, 4)} ${numericPhoneNumber.slice(
        4,
        12
      )}`;
    } else if (
      numericPhoneNumber.startsWith("92") &&
      numericPhoneNumber.length === 12
    ) {
      // Format as a Pakistan number (e.g., +92 300 1234567)
      return `+92 ${numericPhoneNumber.slice(2, 5)} ${numericPhoneNumber.slice(
        5,
        12
      )}`;
    } else {
      return phoneWithCountryCode;
    }
  }

  const handleFuneralchange = (e) => {
    console.log("e", e.target);
    e.preventDefault();
    const { name, value } = e.target;
    setFuneralData({
      ...funeralData,
      [name]: value,
    });
  };

  const handleFuneralRadioChange = (name, value) => {
    setFuneralData({
      ...funeralData,
      [name]: value,
    });
  };
  const handleFuneralPhoneChange = (name, value) => {
    setFuneralData({
      ...funeralData,
      [name]: value,
    });
  };
  const handleFuneralSelectChange = (name, value) => {
    setFuneralData({
      ...funeralData,
      [name]: value,
    });
  };
  const submitFuneralData = () => {
    console.log("submit data funerl", funeralData);
    handelCloseFuneralModal();
    createFuneralWishes();
  };

  const handleUpdateFuneralchange = (e) => {
    console.log("e", e.target);
    e.preventDefault();
    const { name, value } = e.target;
    setUpdateFuneralObject({
      ...updateFuneralObject,
      [name]: value,
    });
  };

  const handleUpdateFuneralRadioChange = (name, value) => {
    if (updateFuneralObject && updateFuneralObject["cremation1"] === "Burial") {
      setUpdateFuneralObject({
        ...updateFuneralObject,
        ["cremation"]: null,
        [name]: value,
      });
    }
    if (
      updateFuneralObject &&
      updateFuneralObject["cremation1"] === "Cremation"
    ) {
      console.log("here in cremation setting");
      setUpdateFuneralObject({
        ...updateFuneralObject,
        ["burial"]: null,
        [name]: value,
      });
    }
    if (value === "Stay On") {
      if (updateFuneralObject[`${name}ReturnTo`]) {
        console.log(
          "updateFuneralObject[`${name}ReturnTo`]",
          updateFuneralObject[`${name}ReturnTo`]
        );
        // delete updateFuneralObject[`${name}ReturnTo`];
        // delete updateFuneralObject[`${name}ReturnTo`];
        setUpdateFuneralObject({
          ...updateFuneralObject,
          [`${name}ReturnTo`]: null,
          [name]: value,
        });
      }
    } else {
      setUpdateFuneralObject({
        ...updateFuneralObject,
        [name]: value,
      });
    }
  };
  console.log("dremetion data", updateFuneralObject);
  const handleUpdateFuneralPhoneChange = (name, value) => {
    setUpdateFuneralObject({
      ...updateFuneralObject,
      [name]: value,
    });
  };
  const handleUpdateFuneralSelectChange = (name, value) => {
    console.log("handlechanges", name, value);
    if (name === "burial") {
    } else if (name === "cremation") {
    }
    setUpdateFuneralObject({
      ...updateFuneralObject,
      [name]: value,
    });
  };
  const submitUpdateFuneralData = () => {
    console.log("submit data funerl", updateFuneralObject);
    handelCloseUpdateFuneralModal();
    updateFuneralWish();
    // createFuneralWishes();
  };
  const handelCloseUpdateFuneralModal = () => {
    setUpdateFuneralWishes(false);
  };
  const createFuneralWishes = async () => {
    var arr = [funeralData];

    try {
      let data = arr;
      if (Array.isArray(data) && data.length > 0) {
        // this.props.handleLoader()
        setLoading(true);

        const ID = localStorage.getItem("accessId");

        let addIPrefer = {
          burial: funeralData.burial && funeralData.burial,
          cremation: funeralData.cremation && funeralData.cremation,
          scatteringLocation:
            funeralData.scatteringLocation && funeralData.scatteringLocation,
          personNextToMe:
            funeralData.personNextToMe && funeralData.personNextToMe,
          headStone: funeralData.headStone && funeralData.headStone,
          preferredFuneral:
            funeralData.preferredFuneral && funeralData.preferredFuneral,
          address: funeralData.address && funeralData.address,
          phone: funeralData.phone && funeralData.phone,
        };
        let addServices = {
          preferredPlace:
            funeralData.preferredPlace && funeralData.preferredPlace,
          otherPreference:
            funeralData.otherPreference && funeralData.otherPreference,
          religiousPreference:
            funeralData.religiousPreference && funeralData.religiousPreference,
          preferredClergyman:
            funeralData.preferredClergyman && funeralData.preferredClergyman,
          clothingPreference:
            funeralData.clothingPreference && funeralData.clothingPreference,
        };
        let addPersonal = {
          weddingBand: funeralData.weddingBand && funeralData.weddingBand,
          weddingBandReturnTo:
            funeralData.weddingBandReturnTo && funeralData.weddingBandReturnTo,
          eyeGlasses: funeralData.eyeGlasses && funeralData.eyeGlasses,
          eyeGlassesReturnTo:
            funeralData.eyeGlassesReturnTo && funeralData.eyeGlassesReturnTo,
          watch: funeralData.watch && funeralData.watch,
          watchReturnTo: funeralData.watchReturnTo && funeralData.watchReturnTo,
          floralPreferences:
            funeralData.floralPreferences && funeralData.floralPreferences,
          musicalSelections:
            funeralData.musicalSelections && funeralData.musicalSelections,
          religiousReadings:
            funeralData.religiousReadings && funeralData.religiousReadings,
          eulogyDeliveredBy:
            funeralData.eulogyDeliveredBy && funeralData.eulogyDeliveredBy,
          favoriteCharities:
            funeralData.favoriteCharities && funeralData.favoriteCharities,
        };
        const isNullishIPrefer = Object.values(addIPrefer).every((value) => {
          if (value === null || value === undefined) {
            console.log("value inside", value);
            return true;
          }
          console.log("value outside", value);
          return false;
        });

        const isNullishServices = Object.values(addServices).every((value) => {
          if (value === null || value === undefined) {
            console.log("value inside", value);
            return true;
          }
          console.log("value outside", value);
          return false;
        });
        const isNullishPersonal = Object.values(addPersonal).every((value) => {
          if (value === null || value === undefined) {
            console.log("value inside", value);
            return true;
          }
          console.log("value outside", value);
          return false;
        });

        console.log("isNullish", isNullishServices);

        if (!isNullishIPrefer) {
          let api_res_prefer = await DEATH_API.addIPrefer(addIPrefer, ID);
        }
        if (!isNullishServices) {
          console.log("addServices", addServices);
          let api_res_services = await DEATH_API.addPlaceofService(
            addServices,
            ID
          );
        }
        if (!isNullishPersonal) {
          let api_res_personal = await DEATH_API.addPersonalAccessories(
            addPersonal,
            ID
          );
        }
        setLoading(false);
        getFuneralWishData();
        // return api_res;
      }
    } catch (error) {
      console.log(error);
      throw new Error(error);
    }
  };

  const handelCloseFuneralModal = () => {
    setAddFuneralWishes(false);
  };

  const handelCloseViewModal = () => {
    setShowViewModal(false);
  };

  const showTooltipModal = () => {
    setTooltipModal(true);
  };

  const handleTooltipCancel = () => {
    setTooltipModal(false);
  };

  const handlechange = (e) => {
    console.log("e", e.target);
    e.preventDefault();
    const { name, value } = e.target;

    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleCurrencychange = (e) => {
    console.log("e", e.target);
    e.preventDefault();
    const { name, value } = e.target;
    const inputString = e.target.value;
    const convertedNumber = parseFloat(inputString.replace(/,/g, ""));

    setaddData({
      ...addData,
      [name]: convertedNumber,
    });
  };
  const handleUpdateCurrencychange = (e) => {
    console.log("e", e.target);
    e.preventDefault();
    const { name, value } = e.target;
    const inputString = e.target.value;
    const convertedNumber = parseFloat(inputString.replace(/,/g, ""));
    setUpdateObject({
      ...updateObject,
      [name]: convertedNumber,
    });
  };
  const handlePhoneChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleUpdatePhoneChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleDocumentChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleDatePickerChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleRadioChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleUpdatechange = (e) => {
    console.log("e", e.target);
    e.preventDefault();
    const { name, value } = e.target;

    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdateDocumentChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdateDatePickerChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdateRadioChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleSelectChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleUpdateSelectChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const SubmitUpdate = () => {
    console.log("updated object submit", updateObject);
    updateBurialExpense();
    handelCloseUpdateModal();
  };
  const submitData = () => {
    console.log("submit data", addData);
    createBurialExpense();
    handelCloseModal();
  };
  const handelCloseModal = () => {
    setShowModal(false);
    setaddData({});
  };
  const handelCloseUpdateModal = () => {
    setShowUpdateModal(false);
  };
  const getSelectedRow = (idx) => {
    console.log("idx", idx);
    setSelectedIndex(idx);
    // get selected row (this will return array of object)
    let selectedRow = funeralWishes.filter((row, index) => {
      return row.id == idx;
    });

    // get first and only element from list and store it in update object
    console.log("selectedRow", selectedRow[0]);
    setUpdateObject(selectedRow[0]);
  };

  useEffect(() => {
    console.log("calling api");
    getFuneralWishes();
    getFuneralWishData();
  }, []);
  const updateBurialExpense = async () => {
    console.log("updateObject", updateObject);
    try {
      setLoading(true);
      let obj = {
        ...updateObject,
        placeName: updateObject.placeName,
        paidFor: updateObject.paidFor,
        amount: updateObject["Amount Paid"] && +updateObject["Amount Paid"],
        DatePaid:
          updateObject["Date Paid"] &&
          moment(updateObject["Date Paid"]).format("LL"),
        note: updateObject.note,
        location: updateObject.location,
        address: updateObject.address,
        director: updateObject.director,
        phoneNumber:
          updateObject["Phone Number"] && updateObject["Phone Number"],
        paymentDate: updateObject["Date Paid"] && updateObject["Date Paid"],
      };
      console.log("passing object", updateObject["Date Paid"]);

      await DEATH_API.updatePrepaidBurial(obj.id, obj);
      setLoading(false);
      getFuneralWishes();
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const deleteSelectedRow = async (idx) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          await DEATH_API.deletePrepaidBurial(idx);
          setLoading(false);

          const updatedRows = funeralWishes.filter((row, index) => {
            return row.id != idx;
          });
          setFuneralWishes(updatedRows);
          getFuneralWishes();
        } catch (error) {
          console.log("error deleting Prepaid Burial");
          console.log(error);
          setLoading(false);
        }
        setTimeout(async () => {
          setLoading(true);
          swal("Deleted!", "Your file has been deleted.", "success");
          setLoading(false);
        }, 0);
      } else {
        swal("Cancelled", "Your file is safe :)", "error");
      }
    });
  };
  const createBurialExpense = async () => {
    // check if already formData contains some data then initialize it with empty
    console.log("addData prepaid", addData);
    var arr = [addData];

    try {
      let data = arr;
      if (Array.isArray(data) && data.length > 0) {
        // this.props.handleLoader()
        setLoading(true);
        let payload = {
          prepaidBurialExpenseForm: [
            {
              placeName:
                addData["Name Of Expense"] && addData["Name Of Expense"],
              paidFor: addData.ItemsPaidFor,
              amount: addData["Amount Paid"] && +addData["Amount Paid"],
              paymentDate: addData["Date Paid"] && addData["Date Paid"],
              note: addData.Notes,
              location:
                addData["Location (if applicable)"] &&
                addData["Location (if applicable)"],
              address:
                addData["Address (if applicable)"] &&
                addData["Address (if applicable)"],
              director:
                addData["Director (if applicable)"] &&
                addData["Director (if applicable)"],
            },
          ],
        };
        if (
          addData["Phone Number (if applicable)"] &&
          addData["Phone Number (if applicable)"] != ""
        ) {
          payload.prepaidBurialExpenseForm[0].phoneNumber =
            addData["Phone Number (if applicable)"];
        }
        let api_res = await DEATH_API.addPrepaidBurial(payload);
        setLoading(false);
        getFuneralWishes();
        console.log("api_res", api_res);
        return api_res;
      }
    } catch (error) {
      console.log(error);
      throw new Error(error);
    }
    setaddData({});
  };

  const getFuneralWishes = async () => {
    try {
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      let data = await DEATH_API.fetchPrepaidBurial(ID);
      if (data && data.data) {
        setFuneralWishes(data.data);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getFuneralWishData = async () => {
    try {
      setLoading(true);
      const ID = localStorage.getItem("accessId");

      setPrefer([]);
      setPersonalItems([]);
      setServicesPlace([]);
      setAllFuneralData({});
      setUpdateFuneralObject({});
      let dataPrefer = await DEATH_API.getIprefer(ID);
      if (dataPrefer && dataPrefer.data) {
        console.log();
        let arr = [dataPrefer.data];

        setUpdateFuneralObject((prevFormData) => ({
          ...prevFormData,
          ...dataPrefer.data,
        }));
        setAllFuneralData((prevFormData) => ({
          ...prevFormData,
          ...dataPrefer.data,
        }));
        setPrefer(arr);
      }
      setLoading(false);

      setLoading(true);
      let dataPersonal = await DEATH_API.getPersonalAccessories(ID);
      if (dataPersonal && dataPersonal.data) {
        let arr = [dataPersonal.data];
        setPersonalItems(arr);
        setUpdateFuneralObject((prevFormData) => ({
          ...prevFormData,
          ...dataPersonal.data,
        }));
        setAllFuneralData((prevFormData) => ({
          ...prevFormData,
          ...dataPersonal.data,
        }));
      }
      setLoading(false);
      setLoading(true);
      let dataPlaces = await DEATH_API.getPlaceofService(ID);
      if (dataPlaces && dataPlaces.data) {
        let arr = [dataPlaces.data];
        setServicesPlace(arr);
        setUpdateFuneralObject((prevFormData) => ({
          ...prevFormData,
          ...dataPlaces.data,
        }));
        setAllFuneralData((prevFormData) => ({
          ...prevFormData,
          ...dataPlaces.data,
        }));
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const deleteFuneralWish = async () => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          if (prefer && prefer[0]) {
            await DEATH_API.deleteIPrefer(prefer[0].id);
          }
          if (personalItems && personalItems[0]) {
            await DEATH_API.deletePersonalAccessories(personalItems[0].id);
          }
          if (servicesPlace && servicesPlace[0]) {
            await DEATH_API.deletePlaceofService(servicesPlace[0].id);
          }
          setLoading(false);
          setFuneralData({});
          getFuneralWishData();
        } catch (error) {
          console.log("error deleting Funeral Wish");
          console.log(error);
          setLoading(false);
        }
        setTimeout(async () => {
          setLoading(true);
          swal("Deleted!", "Your Data has been deleted.", "success");
          setLoading(false);
        }, 0);
      } else {
        swal("Cancelled", "Your Data is safe :)", "error");
      }
    });
  };
  const updateFuneralWish = async () => {
    try {
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      let objPrefer = {
        burial:
          updateFuneralObject.cremation1 === "Burial"
            ? updateFuneralObject.burial && updateFuneralObject.burial
            : null,
        cremation:
          updateFuneralObject.cremation1 === "Cremation"
            ? updateFuneralObject.cremation && updateFuneralObject.cremation
            : null,
        scatteringLocation:
          updateFuneralObject.scatteringLocation &&
          updateFuneralObject.scatteringLocation,
        personNextToMe:
          updateFuneralObject.personNextToMe &&
          updateFuneralObject.personNextToMe,
        headStone:
          updateFuneralObject.headStone && updateFuneralObject.headStone,
        preferredFuneral:
          updateFuneralObject.preferredFuneral &&
          updateFuneralObject.preferredFuneral,
        address: updateFuneralObject.address && updateFuneralObject.address,
        phone: updateFuneralObject.phone && updateFuneralObject.phone,
      };
      let objPlace = {
        preferredPlace:
          updateFuneralObject.preferredPlace &&
          updateFuneralObject.preferredPlace,
        otherPreference:
          updateFuneralObject.otherPreference &&
          updateFuneralObject.otherPreference,
        religiousPreference:
          updateFuneralObject.religiousPreference &&
          updateFuneralObject.religiousPreference,
        preferredClergyman:
          updateFuneralObject.preferredClergyman &&
          updateFuneralObject.preferredClergyman,
        clothingPreference:
          updateFuneralObject.clothingPreference &&
          updateFuneralObject.clothingPreference,
      };
      let objPersonal = {
        weddingBand:
          updateFuneralObject.weddingBand && updateFuneralObject.weddingBand,
        weddingBandReturnTo:
          updateFuneralObject.weddingBandReturnTo &&
          updateFuneralObject.weddingBandReturnTo,
        eyeGlasses:
          updateFuneralObject.eyeGlasses && updateFuneralObject.eyeGlasses,
        eyeGlassesReturnTo:
          updateFuneralObject.eyeGlassesReturnTo &&
          updateFuneralObject.eyeGlassesReturnTo,
        watch: updateFuneralObject.watch && updateFuneralObject.watch,
        watchReturnTo:
          updateFuneralObject.watchReturnTo &&
          updateFuneralObject.watchReturnTo,
        floralPreferences:
          updateFuneralObject.floralPreferences &&
          updateFuneralObject.floralPreferences,
        musicalSelections:
          updateFuneralObject.musicalSelections &&
          updateFuneralObject.musicalSelections,
        religiousReadings:
          updateFuneralObject.religiousReadings &&
          updateFuneralObject.religiousReadings,
        eulogyDeliveredBy:
          updateFuneralObject.eulogyDeliveredBy &&
          updateFuneralObject.eulogyDeliveredBy,
        favoriteCharities:
          updateFuneralObject.favoriteCharities &&
          updateFuneralObject.favoriteCharities,
      };
      // await DEATH_API.updatePrepaidBurial(obj.id, obj);
      if (prefer && prefer[0]) {
        await DEATH_API.updateIPrefer(prefer[0].id, objPrefer, ID);
      } else {
        await DEATH_API.addIPrefer(objPrefer, ID);
      }
      if (personalItems && personalItems[0]) {
        await DEATH_API.updatePersonalAccessories(
          personalItems[0].id,
          objPersonal,
          ID
        );
      } else {
        await DEATH_API.addPersonalAccessories(objPersonal, ID);
      }
      if (servicesPlace && servicesPlace[0]) {
        await DEATH_API.updatePlaceofService(servicesPlace[0].id, objPlace, ID);
      } else {
        await DEATH_API.addPlaceofService(objPlace, ID);
      }
      setLoading(false);
      getFuneralWishData();
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <div>
      {showModal && (
        <AddModal
          show={showModal}
          close={handelCloseModal}
          fields={fields}
          modalTitle="Add New Prepaid Burial Expenses"
          handlechange={handlechange}
          handleCurrencychange={handleCurrencychange}
          submitData={submitData}
          handleDocumentChange={handleDocumentChange}
          handleDatePickerChange={handleDatePickerChange}
          handleRadioChange={handleRadioChange}
          handlePhoneChange={handlePhoneChange}
          handleSelectChange={handleSelectChange}
        />
      )}
      {showUpdateModal && (
        <UpdateModal
          show={showUpdateModal}
          close={handelCloseUpdateModal}
          fields={update_fields}
          modalTitle="Update Prepaid Burial Expenses"
          handlechange={handleUpdatechange}
          handleUpdateCurrencychange={handleUpdateCurrencychange}
          submitData={SubmitUpdate}
          handleDocumentChange={handleUpdateDocumentChange}
          handleDatePickerChange={handleUpdateDatePickerChange}
          handleRadioChange={handleUpdateRadioChange}
          handleUpdateSelectChange={handleUpdateSelectChange}
          handleUpdatePhoneChange={handleUpdatePhoneChange}
          obj={updateObject}
        />
      )}
      {showViewModal && (
        <ViewModal
          show={showViewModal}
          close={handelCloseViewModal}
          fields={update_fields}
          modalTitle="View Prepaid Burial Expenses"
          obj={updateObject}
        />
      )}
      {addFuneralWishes && (
        <AddFuneralModal
          show={addFuneralWishes}
          close={handelCloseFuneralModal}
          fields={funeralFields}
          modalTitle="Add Funeral Wish"
          handlechange={handleFuneralchange}
          submitData={submitFuneralData}
          handleRadioChange={handleFuneralRadioChange}
          handlePhoneChange={handleFuneralPhoneChange}
          handleSelectChange={handleFuneralSelectChange}
          role={props.role}
        />
      )}
      {updateFuneralWishes && (
        <UpdateFuneralModal
          show={updateFuneralWishes}
          close={handelCloseUpdateFuneralModal}
          fields={funeralUpdateFields}
          modalTitle="Update Funeral Wish"
          handlechange={handleUpdateFuneralchange}
          submitData={submitUpdateFuneralData}
          handleRadioChange={handleUpdateFuneralRadioChange}
          handlePhoneChange={handleUpdateFuneralPhoneChange}
          handleSelectChange={handleUpdateFuneralSelectChange}
          obj={updateFuneralObject}
          role={props.role}
        />
      )}
      <Modal
        centered
        visible={tooltipModal}
        footer={null}
        onCancel={handleTooltipCancel}>
        <Style.ModalTitle> Funeral Wishes</Style.ModalTitle>
        <div style={{}}>
          <div className="">
            <Style.ModalDetails>
              If the Plan Creator has chosen to pay or earmark certain
              instructions relevant to their burial or ceremony, it can be found
              in this feature. Details include name of facility, location, items
              paid for, when paid, how much total, name of funeral home
              director, and personal notes.
            </Style.ModalDetails>
          </div>
        </div>
      </Modal>

      <Style.MainHeading
        style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          Funeral Wishes{" "}
          <Style.HelpIcon
            src={helpIcon}
            alt="helpicon"
            onClick={() => {
              showTooltipModal();
            }}></Style.HelpIcon>
        </div>
        <div>
          <React.Fragment>
            <div style={{ display: "flex", justifyContent: "end" }}>
              <div>
                <Style.Button
                  onClick={() => {
                    console.log(
                      "alldata funeral1",
                      JSON.stringify(allFuneralData) === "{}"
                    );
                    setDropdown(!dropdown);
                    console.log("alldata funeral", allFuneralData);
                    // getSelectedRow(record.id);
                  }}>
                  {JSON.stringify(allFuneralData) === "{}" ? (
                    <React.Fragment> + </React.Fragment>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginLeft: "4px",
                      }}>
                      <img
                        src={penImage}
                        style={{
                          height: "20px",
                          width: "20px",
                          marginRight: "4px",
                          marginBottom: "4px",
                        }}
                        alt="penImage"></img>
                    </div>
                  )}
                </Style.Button>
                {dropdown && (
                  <>
                    <div
                      onClick={() => {
                        setDropdown(false);
                      }}
                      className=""
                      style={{
                        position: "fixed",
                        width: "100vw",
                        height: "100vh",
                        background: "black",
                        opacity: "0.1",
                        top: "0",
                        left: "0",
                        right: "0",
                        bottom: "0",
                        zIndex: "999",
                      }}></div>

                    <div class="dropdown" style={{ zIndex: "9999" }}>
                      <ul className="dropdownul">
                        {JSON.stringify(allFuneralData) === "{}" && (
                          <li
                            className="liHover"
                            onClick={() => {
                              setAddFuneralWishes(true);
                              setDropdown(false);
                            }}>
                            Add
                          </li>
                        )}
                        {props.role !== "protrustee" && (
                          <li
                            className="liHover"
                            onClick={() => {
                              // deleteSelectedRow(record.id);
                              deleteFuneralWish();
                              setDropdown(false);
                            }}>
                            Delete
                          </li>
                        )}

                        {JSON.stringify(allFuneralData) !== "{}" && (
                          <li
                            className="liHover"
                            onClick={() => {
                              setUpdateFuneralWishes(true);
                              setDropdown(false);
                            }}>
                            Update
                          </li>
                        )}
                      </ul>
                    </div>
                  </>
                )}
              </div>
            </div>
          </React.Fragment>
        </div>
      </Style.MainHeading>
      {/* new form funeral data*/}

      <Style.HealthCard>
        <Style.HealthCardHeader>
          <Style.Title style={{}}>I Prefer</Style.Title>
        </Style.HealthCardHeader>
        <ListPaginated cols={preferCols} rows={prefer}></ListPaginated>
      </Style.HealthCard>

      <Style.HealthCard>
        <Style.HealthCardHeader>
          <Style.Title style={{}}>Place of Services</Style.Title>
        </Style.HealthCardHeader>
        <ListPaginated cols={placeCols} rows={servicesPlace}></ListPaginated>
      </Style.HealthCard>
      <Style.HealthCard>
        <Style.HealthCardHeader>
          <Style.Title style={{}}>Personal Accessories</Style.Title>
        </Style.HealthCardHeader>
        <ListPaginated cols={personalCols} rows={personalItems}></ListPaginated>
      </Style.HealthCard>

      <Style.MainHeading
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "1rem",
        }}>
        <div>
          <Style.HeaderImg src={Safe} alt="Safe"></Style.HeaderImg>
          Prepaid Burial Expenses{" "}
          <Style.HelpIcon
            src={helpIcon}
            alt="helpicon"
            onClick={() => {
              showTooltipModal();
            }}></Style.HelpIcon>
        </div>
        <div>
          {props.role !== "trustee" && props.role !== "protrustee" ? (
            <React.Fragment>
              <div style={{ display: "flex", justifyContent: "end" }}>
                <div>
                  <Style.Button
                    onClick={() => {
                      setShowModal(true);
                    }}>
                    +
                  </Style.Button>
                </div>
              </div>
            </React.Fragment>
          ) : (
            ""
          )}
        </div>
      </Style.MainHeading>
      <Style.HealthCard>
        <Style.HealthCardHeader>
          <Style.Title style={{}}>Prepaid Burial Expenses</Style.Title>
        </Style.HealthCardHeader>
        <List cols={cols} rows={funeralWishes}></List>
        {/* <Table data={data} name={"FuneralWishes"} /> */}
      </Style.HealthCard>
      <Loader isLoading={loading} />
    </div>
  );
};
